export const GET_PRODUCTS_IN_STOCK = 'GET_PRODUCTS_IN_STOCK';
export const GET_MONTHLY_REPORT = 'GET_MONTHLY_REPORT';
export const GET_ALL_PRODUCTS_BY_CUSTOMER = 'GET_ALL_PRODUCTS_BY_CUSTOMER';
export const GET_ALL_SUPPLIER_AND_PRODUCTS = 'GET_ALL_SUPPLIER_AND_PRODUCTS';
export const CHECK_PRODUCT_IN_STOCK = 'CHECK_PRODUCT_IN_STOCK';
export const CHECK_STOCK = 'CHECK_STOCK';
export const CLEAR_STATE = 'CLEAR_STATE';
